<template>
  <Browser :key="updateWhenParamsChange" />
</template>

<script>
 import Browser from '@/components/Browser.vue'

 export default {
   components: { Browser },
   // see @/components/Browser.vue for title
   computed: {
     updateWhenParamsChange() {
       return this.path
     },
     path() {
       return this.$route.path
     }
   }
 }
</script>
